<template>
  <div style="height: 100vh; width: 100%">
    <div style="width: 100%; display: none; height: 0%">
      <img id="imageid" :src="profpic" />
      <canvas id="imgCanvas" />
      <pdf-make
        ref="pdfMake"
        style="width: 100%"
        :content="content"
        :pageSize="'A4'"
        :pageOrientation="'portrait'"
        :show="true"
        :info="{ title: title }"
        @change="
          (e) => {
            src = e;
          }
        "
      >
      </pdf-make>
    </div>
    <iframe
      id="content-frame"
      :src="src"
      style="width: 100%; display: inline-block; height: 100%"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import PdfMake from "@/components/PdfMake";
// import {docContent} from '@/data/TemplateSuratRujukBalik.js'
import { headerImage } from "@/data/headerImage.js";
import { tandaOperasiImage } from "@/data/tandaOperasiImage.js";
import {
  labelValueFormatter,
  getRuangOperasi,
  getReadableDate,
} from "@/data/helper.js";
export default {
  name: "DocPenandaanLokasiOperasi",
  components: {
    PdfMake,
  },
  data() {
    return {
      title: "Penandaan Lokasi Operasi",
      src: "",
      operasi: {},
      content: [],
      profpic: "https://103.27.207.58/backend/public/images/icon_customer.png",
    };
  },
  methods: {
    executeDocument: function() {
      document.getElementById("content-frame").contentWindow.window.print();
    },
    toDataUrl: function(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },
    fetchData: async function() {
      let result = await this.$store.state.HTTP.get(
        `operasi_laporan?id_operasi=${this.operasi.id}`
      );
      if (result.data.data.length) {
        this.id_laporan = result.data.data[0].id;
        let result2 = await this.$store.state.HTTP.get(
          `operasi_laporan/${this.id_laporan}`
        );
        this.operasi.laporan = result2.data;
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    // this.content = docContent;
    this.operasi = JSON.parse(
      this.CryptoJS.AES.decrypt(
        this.$route.params.slug.replace(/fRWdSl45h/g, "/"),
        this.$store.state.simrsSecretPassphrase
      ).toString(this.CryptoJS.enc.Utf8)
    );
    await this.fetchData();
    var draft = {
      title: "FORMULIR PENANDAAN LOKASI OPERASI",
      intro: `Saya Menyatakan bahwa lokasi yang telah ditetapkan pada diagram adalah benar.`,
      arr1: [
        { label: "Nama Pasien", value: this.operasi.ralan.pasien.nama },
        {
          label: "Tanggal Lahir",
          value: this.operasi.ralan.pasien.formatted_tgl_lahir_umur,
        },
        {
          label: "Jenis Kelamin",
          value: this.operasi.ralan.pasien.jen_kelamin,
        },
        { label: "No. RM", value: this.operasi.ralan.pasien.no_rm },
        { label: "Agama", value: this.operasi.ralan.pasien.agama },
      ],
      arr2: [
        { label: "Tanggal ", value: getReadableDate(this.operasi.tanggal) },
        {
          label: "Ruangan",
          value: getRuangOperasi(this.operasi.laporan.id_operasi_ruangan),
        },
        {
          label: "Jenis Tindakan",
          value: `${this.operasi.nama_operasi} - ${this.operasi.laporan.golongan_tindakan} ( ${this.operasi.laporan.kategori_tindakan} - Anestesi ${this.operasi.laporan.jenis_anastesi} )`,
        },
      ],
    };
    var sign1 = `

    Pasien/Keluarga




    ( __________________________ )`;
    var sign2 = `

    Dokter




    (  __________________________  )`;
    let arr1 = labelValueFormatter(draft.arr1, 80);
    let arr2 = labelValueFormatter(draft.arr2, 90);
    this.content = [
      {
        image: headerImage,
        width: 529,
      },
      {
        text: draft.title,
        style: "subtitle",
      },
      {
        columns: [[...arr1], [...arr2]],
      },
      {
        image: tandaOperasiImage,
        width: 529,
      },
      {
        style: "paragraph",
        text: draft.intro,
      },
      {
        columns: [
          {
            style: "sign",
            text: sign1,
          },
          {
            style: "sign",
            text: "",
          },
          {
            style: "sign",
            text: sign2,
          },
        ],
      },
    ];
  },
};
</script>
